import type { MediaCapabilities } from '@dicetechnology/dice-doris';
import { EncryptionModes, StreamProtocols } from '@dicetechnology/dice-doris';

export const preferDashStreamsInMediaCapabilities = (capabilities: MediaCapabilities): MediaCapabilities => {
    const protocolOrder = { [StreamProtocols.DASH]: 1, [StreamProtocols.HLS]: 2 };
    const encryptionModeOrder = { [EncryptionModes.CTR]: 1, [EncryptionModes.CBC]: 2 };

    return {
        mediaCapabilities: capabilities.mediaCapabilities.map((value) => {
            const reorderedProtocols = [...value.protocols].sort((a, b) => {
                if (protocolOrder[a] < protocolOrder[b]) {
                    return -1;
                }
                if (protocolOrder[a] > protocolOrder[b]) {
                    return 1;
                }
                return 0;
            });

            const reorderedValue = {
                ...value,
                protocols: reorderedProtocols
            };

            if ('encryptionMode' in reorderedValue) {
                const reorderedEncryptionModes = [...reorderedValue.encryptionMode].sort((a, b) => {
                    if (encryptionModeOrder[a] < encryptionModeOrder[b]) {
                        return -1;
                    }
                    if (encryptionModeOrder[a] > encryptionModeOrder[b]) {
                        return 1;
                    }
                    return 0;
                });
                reorderedValue.encryptionMode = reorderedEncryptionModes;
            }

            return reorderedValue;
        })
    };
};
